import { T, Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';
import { InputState } from './input.state';
import { CSS, Style } from './switch.input.style';

addStyles(Style);

function toggleState(state: InputState<boolean>) {
	state.setValue(!state.value);
	state.setFocused(true);
	state.setFocused(false);
}

export const SwitchInput = {
	view(state: InputState<boolean>): MithrilVNode {
		const checked = Boolean(state.value);

		return m('div', { className: CSS.container }, [
			m('label', { for: state.id, className: CSS.label }, [
				m('input', {
					type: 'checkbox',
					className: CSS.input,
					id: state.id,
					checked,
					onchange: () => toggleState(state),
				}),
				m('span', { className: CSS.slider }),
			]),
			m('span', Translate(checked ? T.YES : T.NO)),
		]);
	},
};
